import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const itemDepreciationList = createAsyncThunk(
  'item-depreciation-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-depreciation/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeItemDepreciation = createAsyncThunk(
  'item-depreciation-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-item-depreciation/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getItemDepreciationById = createAsyncThunk(
  'item-depreciation-get',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-depreciation/edit/` + id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const itemDepreciationReport = createAsyncThunk(
  'item-depreciation-report',
  async (params: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-item-depreciation/report`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printItemDepreciationReport = createAsyncThunk(
  'print-item-depreciation-report',
  async (params: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-item-depreciation/report-print`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSchoolExistsItemList = createAsyncThunk(
  'school-exists-item-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-item-depreciation/get_exists_item_stock`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type DepreciationState = {
  errors: any
}

const initialState: DepreciationState = {
  errors: '',
}

export const ItemDepreciationSlice = createSlice({
  name: 'item-depreciation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeItemDepreciation.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = ItemDepreciationSlice.actions
export default ItemDepreciationSlice.reducer
